import { CSSProperties, useEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";

interface ClampedTextProps {
  text: string;
  lines: number;
  className?: string;
  buttonClassName?: string;
  moreLabel?: string;
  lessLabel?: string;
}

export const ClampedText = ({
  text,
  lines,
  className,
  buttonClassName,
  moreLabel = "View more",
  lessLabel = "View less",
}: ClampedTextProps) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const element = textRef.current;

    if (!element || expanded) return;

    setIsOverflowing(element.scrollHeight > element.clientHeight);
  }, [expanded, lines, text]);

  const clampStyle: CSSProperties | undefined = expanded
    ? undefined
    : {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: lines,
        overflow: "hidden",
      };

  return (
    <div className="flex flex-col gap-1">
      <p
        ref={textRef}
        style={clampStyle}
        className={twMerge("whitespace-pre-wrap break-words", className)}
      >
        {text}
      </p>
      {isOverflowing && (
        <button
          type="button"
          onClick={() => setExpanded((previous) => !previous)}
          className={twMerge(
            "w-fit leading-5 text-primary-600 focus:outline-none",
            buttonClassName,
          )}
        >
          {expanded ? lessLabel : moreLabel}
        </button>
      )}
    </div>
  );
};
